import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { App, plugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress/src'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import store from './store'
import './utils'
import './utils/libs'
import './plugins'

Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(plugin)
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(CKEditor)
Vue.component('v-select', vSelect)

InertiaProgress.init()

const el = document.getElementById('app')

new Vue({
  metaInfo: {
    titleTemplate: (title) => title ? `${title} - InterAdmin` : 'InterAdmin',
  },
  store,
  render: h =>
    h(App, {
      props: {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: name => import(`@/views/${name}`).then(module => module.default),
      },
    }),
}).$mount(el)
